import { Spin } from "antd";
import React, { memo, useEffect } from "react";
import styled from "styled-components";
import { FullImageList } from "../../FullImageList";
import { SaleInfoCard, clampSaleCardScale, useResponsiveScale } from "../SaleInfoCard";

type TwoProps = {
  item: any;
  num: number;
  type: "top" | "bottom";
  all?: any[];
  allok?: boolean;
  fontScale?: number;
  isActive?: boolean;
};

const TwoComponent: React.FC<TwoProps> = ({ item, num, type, all = [], allok = false, fontScale = 1, isActive = false }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  const [loading, setLoading] = React.useState(true);
  let [print, setPrint] = React.useState<any>(  );
  // useEffect(() => {
  //
  //   console.log('all', all)
  //
  //   if(all?.length > 0){
  //     except = all.filter((i:any, index:any) => JSON.stringify(i) != JSON.stringify(item[num]?.saleInfo));
  //     //랜덤으로 1개
  //     if(except){
  //       if(except?.length > 1){
  //         except = except[Math.floor(Math.random() * except?.length)];
  //       }else{
  //         except = except[0];
  //       }
  //     }
  //   }
  //   if(except){
  //     setPrint(except);
  //   }
  // }, [item, all]);

  const sourceList = Array.isArray(item) ? item : [item];
  const currentSlot = sourceList[num] ?? sourceList[0];
  const baseWidth = type === "bottom" ? 467 : 464;
  const scale = useResponsiveScale(ref, baseWidth, { min: 0.6, max: 1.2 });
  const displayScale = clampSaleCardScale(scale * fontScale);

  useEffect(() => {
    setPrint(currentSlot?.saleInfo);
  }, [currentSlot]);

  useEffect(() => {
    if (item) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [item]);

  // useEffect(() => {
  //   console.log('print', print)
  // }, [print]);

  if (loading) {
    if (type === "bottom") {
      return (
        <TwoBottomTextContainer ref={ref}>
          <Spin size="large" />
        </TwoBottomTextContainer>
      );
    } else {
      return (
        <TwoTopTextContainer ref={ref}>
          <Spin size="large" />
        </TwoTopTextContainer>
      );
    }
  }

  if (type === "bottom") {
    return (
      <>
        {print?.saleType ?
          <TwoBottomTextContainer ref={ref}>
            <SaleInfoCard
              info={print}
              scale={displayScale}
              showDescription={false}
            />
          </TwoBottomTextContainer>

          :

          <TwoBottomTextContainer ref={ref}>
            <FullImageList
              key={`two-bottom-${num}-${isActive ? 'active' : 'idle'}`}
              imagelist={currentSlot?.imageUrlList}
              isWidth={true}
              setItem={sourceList}
              type={"two"}
              num={num}
              width={'467px'}
              height={'389px'}
              globalScale={fontScale}
              isActive={isActive}
              deferUntilActive
            />
          </TwoBottomTextContainer>
        }
      </>
    );
  }

  return (
    <TwoTopTextContainer ref={ref}>
      <SaleInfoCard
        info={print}
        scale={displayScale}
        showDescription={true}
      />
    </TwoTopTextContainer>
  );
};

export const Two = memo(
  TwoComponent,
  (prev, next) =>
    prev.item === next.item &&
    prev.num === next.num &&
    prev.type === next.type &&
    prev.fontScale === next.fontScale &&
    prev.isActive === next.isActive
);
const TwoBottomTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const TwoTopTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
